module.exports = __webpack_public_path__ + "assets/img/img-fv-03.bf5e208e.png";